





















import { defineComponent, ref } from '@vue/composition-api';
import StratifyForm from './StratifyForm.vue';

export default defineComponent({
	components: {
		StratifyForm,
	},
	props: {
		initialFieldIds: {
			type: Array as () => string[],
		},
	},
	setup() {
		const isDialogVisible = ref<boolean>(false);

		const handleClick = () => {
			isDialogVisible.value = true;
		};

		return {
			handleClick,
			isDialogVisible,
		};
	},
});
